import { render, staticRenderFns } from "./SyncScoreLms.vue?vue&type=template&id=40916a34&"
import script from "./SyncScoreLms.vue?vue&type=script&lang=js&"
export * from "./SyncScoreLms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports